import type { Space } from '@cocoonspace/sdk-js/types/space'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { Price } from '~/components/price'

export const StandardPrice = ({
	space,
	className,
	hideDay,
}: {
	space: Pick<Space, 'prices'>
	className?: string
	hideDay?: boolean
}) => {
	const { t } = useLingui()

	return (
		<div
			className={cn('relative flex flex-col items-end gap-y-1', className)}
			data-testid='standard-price'
		>
			<span className='whitespace-nowrap text-xs'>{t`À partir de`}</span>

			<Price
				className='leading-none'
				price={space.prices?.weekday_min?.hour_standard}
				suffix='hourlyLong'
				suffixClassName='mb-px text-xs'
			/>

			{!hideDay && (
				<Price
					className='leading-none'
					price={space.prices?.weekday_min?.day_standard}
					suffix='dailyLong'
					suffixClassName='mb-px text-xs'
				/>
			)}
		</div>
	)
}
